import DAPFormController from './dap.form.controller';

export default {
    template: require('./dap.form.html'),
    controller: DAPFormController
};
